export const MODAL_QAM_ACTIVITY_FORM_HEADER_NEW_ITEM = "MODAL_QAM_ACTIVITY_FORM_HEADER_NEW_ITEM";
export const MODAL_QAM_ENTITY_FORM_HEADER_NEW_ITEM = "MODAL_QAM_ENTITY_FORM_HEADER_NEW_ITEM";
